<template>
  <div id="app__ernest">
    <header class="app__header__ernest">
      <div>
        <u-icon>f</u-icon>
      </div>
      <div>
        <div><span>Mes questions</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>

    <section class="app__section__ernest">
      <v-card>
        <v-card-title>
          {{ $t('components.questions.list.header.name') }}
          <v-spacer/>
          <v-checkbox v-model="repoFilter"
            :label="$t('components.questions.list.header.filter')"/>
          <v-spacer/>
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('components.questions.list.header.search')"
            single-line
            hide-details
            color="valid"
          />
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="questionList"
          :search="search"
        >
          <template v-slot:item.label="{ item }">
            <router-link :to="modifUrl(item)"
                         v-if="isSelectedRepository(item.repositoryID)">
              {{ item.label }}
            </router-link>
            <v-tooltip bottom v-else color="#f0f0f0">
              <template slot="activator" slot-scope="{ on }">
                <span v-on="on" class="text--disabled">
                {{ item.label }}
                </span>
              </template>
              <span>
                Référentiel&nbsp;: {{ getRepositoryLabel(item.repositoryID) }}
              </span>
            </v-tooltip>
          </template>

          <template v-slot:item.text="{ item }">
            <router-link :to="modifUrl(item)"
                         v-if="isSelectedRepository(item.repositoryID)">
              {{ getTruncatedText(item) }}
            </router-link>
            <v-tooltip bottom v-else color="#f0f0f0">
              <template slot="activator" slot-scope="{ on }">
                <span v-on="on" class="text--disabled">
                  {{ getTruncatedText(item) }}
                </span>
              </template>
              <span>
                Référentiel&nbsp;: {{ getRepositoryLabel(item.repositoryID) }}
              </span>
            </v-tooltip>
          </template>

          <template v-slot:item.type="{ item }">
            {{ item.displayType }}
          </template>

          <template v-slot:item.updatedAt="{ item }">
            {{ getLocaleUpdatedAt(item.updatedAt) }}
          </template>

          <template v-slot:item.isActive="{ item }">
            <v-icon v-if="item.isActive">check</v-icon>
            <v-icon v-else>close</v-icon>
          </template>

          <template v-slot:item.actions="{ item }">
            <div class="table__actions__buttons" v-if="isSelectedRepository(item.repositoryID)">
              <v-tooltip bottom color="#f0f0f0">
                <template slot="activator" slot-scope="{ on }">
                  <router-link :to="cloneUrl(item)" v-on="on">
                    <div v-on="on">
                      <u-icon>Ù</u-icon>
                    </div>
                  </router-link>
                </template>
                <span>Dupliquer de la question</span>
              </v-tooltip>
            </div>
          </template>

          <template v-slot:no-data>
            {{ $t('components.questions.list.noData.name') }}
          </template>

          <template v-slot:no-results>
            {{ $t('components.questions.list.noResult.name') }}
          </template>
        </v-data-table>
      </v-card>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  name: 'questionsList',
  data () {
    return {
      /**
       * Options de réglage pour le bouton d'ajout
       */
      addButton: {
        direction: 'right',
        fab: false,
        fling: false,
        hover: false,
        tabs: null,
        top: true,
        right: false,
        bottom: false,
        left: true,
        transition: 'scale-transition'
      },
      /**
       * Stocke la valeur du champ de recherche.
       */
      search: '',
      headers: [
        {
          text: this.$t('components.questions.list.columns[0].name'),
          value: 'label'
        },
        {
          text: this.$t('components.questions.list.columns[1].name'),
          value: 'text'
        },
        {
          text: this.$t('components.questions.list.columns[2].name'),
          value: 'type'
        },
        {
          text: this.$t('components.questions.list.columns[3].name'),
          value: 'updatedAt'
        },
        {
          text: this.$t('components.questions.list.columns[4].name'),
          value: 'skillsNumber'
        },
        {
          text: this.$t('components.questions.list.columns[5].name'),
          value: 'isActive'
        },
        {
          value: 'actions',
          sortable: false
        }
      ],
      repoFilter: true
    }
  },
  computed: {
    ...mapGetters('Questions', [
      'questions'
    ]),
    ...mapGetters('Repositories', ['repositorySelected', 'repositories']),
    questionList () {
      const filteredQuestions = this.repoFilter ? this.questions.filter(
        q => q.repositoryID ? q.repositoryID === this.repositorySelected.id : true
      ) : this.questions
      return filteredQuestions.map(q => this.updateType(q))
    }
  },
  async created () {
    await this.loadQuestions()
  },
  methods: {
    ...mapActions('Questions', [
      'loadQuestions'
    ]),
    cloneUrl: item => `/question/creation/${item.type}/${item.id}`,
    getTruncatedText (question) {
      let truncLength = 20
      let truncContinuation = '\u2026'
      return question.text.length < truncLength
        ? question.text
        : question.text.substring(0, truncLength) + truncContinuation
    },
    getLocaleUpdatedAt (updatedAt) {
      return new Date(updatedAt).toLocaleString(navigator.language)
    },
    isSelectedRepository (itemRepositoryId) {
      return itemRepositoryId ? this.repositorySelected.id === itemRepositoryId : true
    },
    getRepositoryLabel (itemRepositoryId) {
      const { name } = this.repositories.find(repository => repository.id === itemRepositoryId)
      return name
    },
    modifUrl: item => `/question/modification/${item.type}/${item.id}`,
    updateType (question) {
      const type = (question.type === 'mcq' && question.isUnique)
        ? 'ucq' : question.type
      return {
        ...question,
        displayType: this.$t(`components.questions.list.type.${type}.name`)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppErnest";
  @import "../../assets/style/styleAppTableListErnest";

  #app__ernest {
    position: relative;
  }
</style>
